module.exports = __webpack_public_path__ + "img/1F976.037051eb.svg";